"use strict";
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.IModelsErrorCode = void 0;
/** Possible error codes. */
var IModelsErrorCode;
(function (IModelsErrorCode) {
    IModelsErrorCode["Unrecognized"] = "Unrecognized";
    IModelsErrorCode["Unknown"] = "Unknown";
    IModelsErrorCode["Unauthorized"] = "Unauthorized";
    IModelsErrorCode["InsufficientPermissions"] = "InsufficientPermissions";
    IModelsErrorCode["RateLimitExceeded"] = "RateLimitExceeded";
    IModelsErrorCode["TooManyRequests"] = "TooManyRequests";
    IModelsErrorCode["InvalidIModelsRequest"] = "InvalidiModelsRequest";
    IModelsErrorCode["RequestTooLarge"] = "RequestTooLarge";
    IModelsErrorCode["ResourceQuotaExceeded"] = "ResourceQuotaExceeded";
    IModelsErrorCode["DataConflict"] = "DataConflict";
    IModelsErrorCode["MutuallyExclusivePropertiesProvided"] = "MutuallyExclusivePropertiesProvided";
    IModelsErrorCode["MissingRequiredProperty"] = "MissingRequiredProperty";
    IModelsErrorCode["MissingRequiredParameter"] = "MissingRequiredParameter";
    IModelsErrorCode["MissingRequiredHeader"] = "MissingRequiredHeader";
    IModelsErrorCode["InvalidValue"] = "InvalidValue";
    IModelsErrorCode["InvalidHeaderValue"] = "InvalidHeaderValue";
    IModelsErrorCode["InvalidRequestBody"] = "InvalidRequestBody";
    IModelsErrorCode["MissingRequestBody"] = "MissingRequestBody";
    IModelsErrorCode["ConflictWithAnotherUser"] = "ConflictWithAnotherUser";
    IModelsErrorCode["InvalidChange"] = "InvalidChange";
    IModelsErrorCode["IModelExists"] = "iModelExists";
    IModelsErrorCode["VersionExists"] = "NamedVersionExists";
    IModelsErrorCode["ChangesetExists"] = "ChangesetExists";
    IModelsErrorCode["NamedVersionOnChangesetExists"] = "NamedVersionOnChangesetExists";
    IModelsErrorCode["ProjectNotFound"] = "ProjectNotFound";
    IModelsErrorCode["IModelNotFound"] = "iModelNotFound";
    IModelsErrorCode["NamedVersionNotFound"] = "NamedVersionNotFound";
    IModelsErrorCode["ChangesetNotFound"] = "ChangesetNotFound";
    IModelsErrorCode["UserNotFound"] = "UserNotFound";
    IModelsErrorCode["BriefcaseNotFound"] = "BriefcaseNotFound";
    IModelsErrorCode["MaximumNumberOfBriefcasesPerUser"] = "MaximumNumberOfBriefcasesPerUser";
    IModelsErrorCode["FileNotFound"] = "FileNotFound";
    IModelsErrorCode["BaselineFileNotFound"] = "BaselineFileNotFound";
    IModelsErrorCode["CheckpointNotFound"] = "CheckpointNotFound";
    IModelsErrorCode["LockNotFound"] = "LockNotFound";
    IModelsErrorCode["NewerChangesExist"] = "NewerChangesExist";
    IModelsErrorCode["InvalidThumbnailFormat"] = "InvalidThumbnailFormat";
    IModelsErrorCode["BaselineFileInitializationFailed"] = "BaselineFileInitializationFailed";
    IModelsErrorCode["ChangesetDownloadFailed"] = "ChangesetDownloadFailed";
})(IModelsErrorCode = exports.IModelsErrorCode || (exports.IModelsErrorCode = {}));
//# sourceMappingURL=IModelsErrorInterfaces.js.map